import { createPortal } from "react-dom";
import { ModalContainer } from "~/common/ModalContainer";

export function VideoModal({
  videoId,
  show,
  onClose,
}: {
  videoId: string;
  show: boolean;
  onClose?: () => void;
}) {
  const handleClose = () => {
    if (onClose) onClose();
  };

  if (!show) return null;

  const el = document.querySelector("#cn-video-modal");
  console.log("found el ", el);

  const header = (
    <div onClick={handleClose} className="tw:w-[66.66%] tw:flex tw:justify-end">
      <div className="tw:bg-cn-btn-primary tw:p-2 tw:rounded-sm tw:cursor-pointer">
        <div className="tw:bg-[url(./assets/images/icons/atom_icon_close@2x.svg)] tw:bg-contain tw:bg-no-repeat tw:w-5 tw:h-5" />
      </div>
    </div>
  );

  return createPortal(
    <ModalContainer header={header} onClose={handleClose}>
      <div className="tw:relative tw:w-[66.66%] tw:overflow-hidden tw:pt-[37.50%]">
        <div className="tw:absolute tw:top-0 tw:left-0 tw:w-full tw:h-full">
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </ModalContainer>,
    el!,
  );
}
